import React, { useEffect } from "react";
import HeaderNav from "./common/HeaderNav";
import Footer from "./Footer";
import faq from "../images/faq.png";

function Faq() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Frequently Asked Questions | VIP Number Studio";
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        "Find answers to common questions about purchasing premium VIP mobile numbers at VIP Number Studio. Learn about our services, payment options, and more."
      );
  }, []);

  return (
    <>
      <HeaderNav activeTabName="Faq" />
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "300px",
          overflow: "hidden",
          marginTop: "60px",
        }}
      >
        {/* Background Image */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundImage: `url(${faq})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>

        {/* Gradient Overlay */}
        <div
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "#000040",
          }}
        ></div>
        {/* Red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "300px",
            height: "300px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            top: "-150px",
            right: "-100px",
            zIndex: 1,
          }}
        ></div>

        {/* Second red circular accent */}
        <div
          style={{
            position: "absolute",
            width: "150px",
            height: "150px",
            backgroundColor: "rgba(255, 0, 0, 0.8)",
            borderRadius: "50%",
            bottom: "-70px",
            left: "50px",
            zIndex: 1,
          }}
        ></div>

        {/* Decorative dots */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "20px",
            display: "flex",
            gap: "5px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.7)",
            }}
          ></div>
        </div>

        {/* Decorative triangle */}
        <div
          style={{
            position: "absolute",
            bottom: "15px",
            right: "60px",
            width: 0,
            height: 0,
            borderLeft: "15px solid transparent",
            borderRight: "15px solid transparent",
            borderBottom: "26px solid rgba(255, 255, 255, 0.15)",
            transform: "rotate(45deg)",
          }}
        ></div>

        {/* Content Container */}
        <div
          style={{
            position: "relative",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 20px",
            zIndex: "2",
          }}
        >
          <h1
            style={{
              color: "white",
              fontSize: "42px",
              fontWeight: "800",
              marginBottom: "16px",
              textAlign: "center",
              textShadow: "2px 2px 8px rgba(0, 0, 0, 0.6)",
            }}
          >
            Frequently Asked Questions
          </h1>

          <p
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "400",
              maxWidth: "700px",
              textAlign: "center",
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.8)",
            }}
          >
            Find all the answers you need to make informed decisions
          </p>

          {/* Decorative Line */}
          <div
            style={{
              width: "80px",
              height: "4px",
              background:
                "linear-gradient(90deg,rgba(255, 255, 255, 0.74), rgb(233, 2, 2))",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          ></div>
        </div>
      </div>
      <div className="terms">
        <div className="container">
          <div className="row">
            <div className="titlex">
              <h1 className="policy-header">Frequently Asked Questions</h1>
            </div>
            <div className="contentx">
              {/* <h5>What is a VIP number?</h5>
                            <p>VIP stands for Very Important Person, therefore, a VIP number means a number which is unique and stands out compared to normal telecom numbers in the market. VIP number is also referred to as 'fancy number'.</p>

                            <h5>What does RTP (Ready To GO) mean?</h5>
                            <p>RTP stands for Ready To Port, this category is a list of numbers which are presently owned by someone else but are readily up for sale. Generally, these are unique and easy to remember numbers whose ownership can be transferred with proper paperwork.</p>

                            <h5>What is MNP?</h5>
                            <p>MNP stands for Mobile Number Portability, it is basically the process to switch your current mobile number to another network service provider without having to buy a new number. It allows you to keep the same number even after changing the number’s service provider.</p>

                            <h5>Can I choose my mobile number?</h5>
                            <p>Yes, that is what we offer, a choice for all. You can suggest a number of your wish or you can even select one from our collection. As always, the choice is yours.</p>

                            <h5>What if I don’t get my desired number?</h5>
                            <p>We will try our best that you do. We will search with operators all across India and will get back to you within the next 48 hours.</p>

                            <h5>What is an outstation customer?</h5>
                            <p>It is the person whose valid proof of address falls outside the telecom circle.
                                Eg:- you buy a Maharashtra number on your Rajasthan address documents. This makes you an outstation customer.</p>

                            <h5>What additional details are required for outstation number?</h5>
                            <p>You have to provide details of the current local address along with a reference for tele-verification.</p>

                            <h5>Can I cancel my booking?</h5>
                            <p>Yes, you cancel your order during tele-verification process. But once the item is shipped, no cancellations can be adjusted.</p>

                            <h5>How to book a number/service?</h5>
                            <p>Select a number then book it. This gives your details to our sales team who will coordinate with you within the next 24 working hrs.</p>

                            <h5>What are the payment options?</h5>
                            <p>You can pay through Net Banking, Credit Card, Debit Card, Bank Transfers and Cash on Delivery only in (Mumbai and Nashik as of now).</p>

                            <h5>How long does it take for delivery and activation of number?</h5>
                            <p>The average delivery time period is 1-3 days while the activation happens instantly using biometric e-KYC.</p>

                            <h5>I am an NRI/tourist; can I buy a new connection online?</h5>
                            <p>Yes, using your passport, visa details and your local address of stay in India you can buy a new connection. Your number will get activated after 48 hours.</p>

                            <h5>Can I buy a number on my family member’s name?</h5>
                            <p>Yes, with that family member’s documents, details and biometric e-KYC in place, you can buy a new number.</p>

                            <h5>Can there be a transfer of ownership of the SIM card?</h5>
                            <p>Transfer of ownership is executable only after a successful activation by visiting the specific operator store along with a request letter and documents. For easy transfers, you can opt for easy to change MNP services too.</p>

                            <h5>The received SIM card is not showing a network? Showing an invalid SIM sign?</h5>
                            <p>Your documents might still be in process. But if the issue is still present after 2 days then please contact us immediately or visit the nearest operator for exchange of SIM/resubmission of documents.</p> */}
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingOne">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                    >
                      <h5>What is a VIP number?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingOne"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        VIP stands for Very Important Person, therefore, a VIP
                        number means a number which is unique and stands out
                        compared to normal telecom numbers in the market. VIP
                        number is also referred to as 'fancy number'.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTwo">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                    >
                      <h5>What does RTP (Ready To GO) mean?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwo"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        RTP stands for Ready To Port, this category is a list of
                        numbers which are presently owned by someone else but
                        are readily up for sale. Generally, these are unique and
                        easy to remember numbers whose ownership can be
                        transferred with proper paperwork.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingThree">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h5>What is MNP?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThree"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      {" "}
                      <p>
                        MNP stands for Mobile Number Portability, it is
                        basically the process to switch your current mobile
                        number to another network service provider without
                        having to buy a new number. It allows you to keep the
                        same number even after changing the number’s service
                        provider.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFour">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFour"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                    >
                      <h5>Can I choose my mobile number?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFour"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFour"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        Yes, that is what we offer, a choice for all. You can
                        suggest a number of your wish or you can even select one
                        from our collection. As always, the choice is yours.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFive">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFive"
                      aria-expanded="false"
                      aria-controls="flush-collapseFive"
                    >
                      <h5>What if I don’t get my desired number?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFive"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFive"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      {" "}
                      <p>
                        We will try our best that you do. We will search with
                        operators all across India and will get back to you
                        within the next 48 hours.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingSix">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSix"
                      aria-expanded="false"
                      aria-controls="flush-collapseSix"
                    >
                      <h5>What is an outstation customer?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSix"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingSix"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        It is the person whose valid proof of address falls
                        outside the telecom circle. Eg:- you buy a Maharashtra
                        number on your Rajasthan address documents. This makes
                        you an outstation customer.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingSeven">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseSeven"
                      aria-expanded="false"
                      aria-controls="flush-collapseSeven"
                    >
                      <h5>
                        What additional details are required for outstation
                        number?
                      </h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseSeven"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingSeven"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        You have to provide details of the current local address
                        along with a reference for tele-verification.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingEight">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseEight"
                      aria-expanded="false"
                      aria-controls="flush-collapseEight"
                    >
                      <h5>Can I cancel my booking?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseEight"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingEight"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        Yes, you cancel your order during tele-verification
                        process. But once the item is shipped, no cancellations
                        can be adjusted.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingNine">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseNine"
                      aria-expanded="false"
                      aria-controls="flush-collapseNine"
                    >
                      <h5>How to book a number/service?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseNine"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingNine"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        Select a number then book it. This gives your details to
                        our sales team who will coordinate with you within the
                        next 24 working hrs.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTen">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTen"
                      aria-expanded="false"
                      aria-controls="flush-collapseTen"
                    >
                      <h5>What are the payment options?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTen"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        You can pay through Net Banking, Credit Card, Debit
                        Card, Bank Transfers and Cash on Delivery only in
                        (Mumbai and Nashik as of now).
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingEleven">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseEleven"
                      aria-expanded="false"
                      aria-controls="flush-collapseEleven"
                    >
                      <h5>
                        How long does it take for delivery and activation of
                        number?
                      </h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseEleven"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingEleven"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        The average delivery time period is 1-3 days while the
                        activation happens instantly using biometric e-KYC.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingTwelve">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwelve"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwelve"
                    >
                      <h5>
                        I am an NRI/tourist; can I buy a new connection online?
                      </h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwelve"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingTwelve"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      {" "}
                      <p>
                        Yes, using your passport, visa details and your local
                        address of stay in India you can buy a new connection.
                        Your number will get activated after 48 hours.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingThirteen">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThirteen"
                      aria-expanded="false"
                      aria-controls="flush-collapseThirteen"
                    >
                      <h5>Can I buy a number on my family member’s name?</h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThirteen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingThirteen"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        Yes, with that family member’s documents, details and
                        biometric e-KYC in place, you can buy a new number.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFourteen">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFourteen"
                      aria-expanded="false"
                      aria-controls="flush-collapseFourteen"
                    >
                      <h5>
                        Can there be a transfer of ownership of the SIM card?
                      </h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFourteen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFourteen"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        Transfer of ownership is executable only after a
                        successful activation by visiting the specific operator
                        store along with a request letter and documents. For
                        easy transfers, you can opt for easy to change MNP
                        services too.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="flush-headingFifteen">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseFifteen"
                      aria-expanded="false"
                      aria-controls="flush-collapseFifteen"
                    >
                      <h5>
                        The received SIM card is not showing a network? Showing
                        an invalid SIM sign?
                      </h5>
                    </button>
                  </h2>
                  <div
                    id="flush-collapseFifteen"
                    class="accordion-collapse collapse"
                    aria-labelledby="flush-headingFifteen"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div class="accordion-body">
                      <p>
                        Your documents might still be in process. But if the
                        issue is still present after 2 days then please contact
                        us immediately or visit the nearest operator for
                        exchange of SIM/resubmission of documents.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Faq;
